import en from "../translations/en.json";
import de from "../translations/de.json";

const translations: Record<string, any> = {
  en,
  de,
};

export const getTranslation = (
  locale: string,
  key: string
): string | undefined => {
  const data = translations[locale];
  if (!data) return undefined;

  return data[key];
};
